(() => {
  const TARGET_METHOD = 'delivery';
  const PRESELECT_FLAG = '__dtx_dingdoong_preselect_local_delivery_applied__';
  const OPENED_ONCE_FLAG = '__dtx_dingdoong_calendar_opened_once__';
  const DATE_BUTTON_SELECTOR = '#dd-container .ot-dingdoong-dropdown__button';

  const applyPreselect = () => {
    const mf = window.dingdoongAppMetafields;
    const sg = mf?.data?.shopGeneral;
    if (!sg) return false;
    if (window[PRESELECT_FLAG]) return true;

    if (sg.defaultMethod !== TARGET_METHOD) sg.defaultMethod = TARGET_METHOD;
    if (mf?.data?.appearance && mf.data.appearance.defaultMethod !== undefined) {
      mf.data.appearance.defaultMethod = TARGET_METHOD;
    }

    try {
      if (typeof window.dingdoongReRenderWidget === 'function') window.dingdoongReRenderWidget();
    } catch {
      // no-op
    }

    window[PRESELECT_FLAG] = true;
    return true;
  };

  const getDateButton = () => {
    const button = document.querySelector(DATE_BUTTON_SELECTOR);
    return button instanceof HTMLElement ? button : null;
  };

  const isCalendarOpen = () => getDateButton()?.getAttribute('aria-expanded') === 'true';

  /** Open calendar once — do not relocate DingDoong DOM (breaks React selection). */
  const openCalendarOnce = () => {
    const button = getDateButton();
    if (!button) return false;
    if (isCalendarOpen()) {
      window[OPENED_ONCE_FLAG] = true;
      return true;
    }
    if (window[OPENED_ONCE_FLAG]) return false;

    try {
      button.click();
    } catch {
      // no-op
    }

    window.setTimeout(() => {
      if (isCalendarOpen()) window[OPENED_ONCE_FLAG] = true;
    }, 120);

    return true;
  };

  let syncScheduled = false;
  const sync = () => {
    if (syncScheduled) return;
    syncScheduled = true;
    requestAnimationFrame(() => {
      syncScheduled = false;
      applyPreselect();
      openCalendarOnce();
    });
  };

  sync();

  const obs = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      if (mutation.type !== 'childList') return false;
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (
          node.id === 'dd-container' ||
          node.matches?.('#dd-container, .ot-dingdoong-dropdown__button, .ot-dingdoong-main') ||
          node.querySelector?.('#dd-container, .ot-dingdoong-dropdown__button')
        ) {
          return true;
        }
      }
      return false;
    });
    if (!relevant) return;
    if (!document.querySelector('#dd-container') && !getDateButton()) return;
    window[OPENED_ONCE_FLAG] = false;
    sync();
  });

  obs.observe(document.documentElement, { subtree: true, childList: true });

  window.setInterval(() => {
    if (!getDateButton()) return;
    if (!isCalendarOpen() && !window[OPENED_ONCE_FLAG]) sync();
  }, 2500);
})();
